var React = require('react');

function ReadMsgInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","fill":"rgb( 213, 218, 224 )","d":"M7.000,7.374 C7.000,7.374 0.017,14.000 0.017,14.000 C0.017,14.000 13.975,14.000 13.975,14.000 C13.975,14.000 7.000,7.374 7.000,7.374 ZM14.000,5.424 C14.000,5.424 14.000,12.367 14.000,12.367 C14.000,12.367 9.990,8.557 9.990,8.557 C9.990,8.557 13.021,6.187 13.021,6.187 C13.021,6.187 7.000,1.520 7.000,1.520 C7.000,1.520 0.985,6.184 0.985,6.184 C0.985,6.184 4.010,8.537 4.010,8.537 C4.010,8.537 0.000,12.352 0.000,12.352 C0.000,12.352 0.000,5.416 0.000,5.416 C0.000,5.416 7.000,0.000 7.000,0.000 C7.000,0.000 14.000,5.424 14.000,5.424 Z"})));
}

ReadMsgInline.defaultProps = {"version":"1.1","baseProfile":"full","xmlnsEv":"http://www.w3.org/2001/xml-events","width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = ReadMsgInline;

ReadMsgInline.default = ReadMsgInline;
